module.exports = __webpack_public_path__ + "img/state_1.3e4c4a2f.png";